{
  "+{percent} %": "+{percent}%",
  "Années-lumière": "Light-Years",
  "Bonds de renard": "Fox Leaps",
  "Boutons dorés": "Golden Buttons",
  "Cascade": "Cascade",
  "Cascade continue": "Endless Cascade",
  "Cavalcade": "Cavalcade",
  "Chambre d’écho": "Echo Chamber",
  "Charge immobile un tir qui traverse la foule, bien au-dessus des petites bad vibes.": "Charges a shot standing still that goes through the crowd, high above the small bad vibes.",
  "Chaîne des éléments": "Elemental Chain",
  "Choisis une sortie sur la piste pour filer vers ta prochaine scène.": "Pick an exit on the floor to head for your next stage.",
  "Comète": "Comet",
  "Coup d’épaule": "Shoulder Charge",
  "Couvée nombreuse": "Big Brood",
  "Danse avec ses drapeaux et enchaîne les éléments sur la mesure : feu, eau, air, terre.": "Dances with their flags and chains the elements bar by bar: fire, water, air, earth.",
  "Deux lucioles de plus volent avec toi.": "Two more fireflies fly with you.",
  "Deux poussins de plus marchent dans ta bande.": "Two more chicks walk in your band.",
  "Double fond": "False Bottom",
  "Dragon jumeau": "Twin Dragon",
  "Dub des champignons": "Mushroom Dub",
  "Débandade": "Stampede",
  "Déchaîné": "Unleashed",
  "Défis : {list}, {percent} % de score en plus": "Challenges: {list}, {percent}% more score",
  "Démesure": "Larger Than Life",
  "Elle brûle qui n'est pas à l'ombre.": "Burns whoever isn’t in the shade.",
  "Emprise": "Sway",
  "Encore !": "One More Time!",
  "Encre fraîche": "Fresh Ink",
  "Entre chien et loup": "Blue Hour",
  "Fosse illuminée": "Lit-Up Pit",
  "Frappe de mule": "Thunder Strike",
  "Frappe enroulée": "Curler",
  "Frappe son ballon de bad vibe en bad vibe, et court pour frapper plus fort.": "Kicks a ball from bad vibe to bad vibe, and runs to kick harder.",
  "Grand halo": "Grand Halo",
  "Grand motif": "Grand Motif",
  "Grand pas": "Long Stride",
  "Grand rappel": "Grand Encore",
  "Grande cascade": "Grand Cascade",
  "Grands astres": "Great Lights",
  "Half-time": "Half-time",
  "Hibou": "Owl",
  "Il noie les pièges sous ses flaques.": "Drowns the traps under their puddles.",
  "Il siffle, et n'encaisse les coups qu'une mesure sur deux.": "Whines, and only takes hits every other bar.",
  "L'Orage": "The Storm",
  "La Canicule": "The Heatwave",
  "La cérémonie": "The Ceremony",
  "Laisse ses étoiles au sol et les relie en constellations qui piègent les bad vibes et renforcent les tirs de l’équipe.": "Leaves their stars on the ground and links them into constellations that trap the bad vibes and boost the team’s shots.",
  "Lance ses trois massues et court les ramasser, en rythme.": "Throws three clubs and runs to catch them, in rhythm.",
  "Lancer d’épaule": "Shoulder Throw",
  "Lanterne grande ouverte": "Wide-Open Lantern",
  "Lanterne ouverte": "Open Lantern",
  "Lanterne pleine": "Full Lantern",
  "Lanterne vite rouverte": "Quick-Opening Lantern",
  "Le Faux contact": "The Loose Wire",
  "Le Larsen": "The Screech",
  "Le boss a plus de vie": "The boss has more health",
  "Le festival a tenu": "The festival held",
  "Les Moustiques": "The Mosquitoes",
  "Les ailes de bois": "Wooden Wings",
  "Les bad vibes arrivent plus nombreuses": "More bad vibes show up",
  "Les bad vibes courent plus vite": "Bad vibes run faster",
  "Les quatre marches": "The Four Steps",
  "Les scènes du festival": "The festival’s stages",
  "Lucioles vagabondes": "Wandering Fireflies",
  "Là où tu vises, l’éclipse frappe, ralentit et éclate en rayons de soleil, puis ton horloge bascule.": "Where you aim, the eclipse hits, slows and bursts into rays of sun, then your clock flips.",
  "Lâche des dragons d’encre qui traversent toute la foule.": "Lets loose ink dragons that go through the whole crowd.",
  "L’ombre de ton éclipse couvre bien plus large.": "Your eclipse casts a much wider shadow.",
  "L’ombre de ton éclipse couvre deux fois plus large.": "Your eclipse casts a shadow twice as wide.",
  "L’ombre de ton éclipse couvre plus large.": "Your eclipse casts a wider shadow.",
  "L’élément du moment où tu la lances se déchaîne en feu, en vague, en tornade ou en faille.": "Whichever element is up when you cast it is unleashed as fire, a wave, a tornado or a rift.",
  "Main sûre": "Steady Hand",
  "Mandala de feu": "Fire Mandala",
  "Massues": "Clubs",
  "Massues lestées": "Weighted Clubs",
  "Motif": "Motif",
  "Nuit de chasse": "Night Hunt",
  "Pas de géant": "Giant Step",
  "Perséides": "Perseids",
  "Petit creux": "Peckish",
  "Plante devant la scène des bâtons lumineux qui pulsent sur le temps, et les fait tous éclater d’un rappel.": "Plants glowsticks in front of the stage that pulse on the beat, and bursts them all with an encore.",
  "Plein air": "Open Air",
  "Plein ciel": "Full Sky",
  "Pluie de météores": "Meteor Shower",
  "Prend racine sans bouger, et son renard bondit de bad vibe en bad vibe.": "Takes root standing still, and their fox leaps from bad vibe to bad vibe.",
  "Racines": "Roots",
  "Racines profondes": "Deep Roots",
  "Rappel": "Encore",
  "Rayon et croissants ensemble 1,5 mesure après ta bascule.": "Ray and crescents together for 1.5 bars after your flip.",
  "Rayon et croissants ensemble 2 mesures après ta bascule.": "Ray and crescents together for 2 bars after your flip.",
  "Rayon et croissants ensemble une mesure après ta bascule.": "Ray and crescents together for one bar after your flip.",
  "Rayonnement": "Radiance",
  "Regroupez-vous dans la même sortie pour choisir votre prochaine scène.": "Gather in the same exit to pick your next stage.",
  "Remontés à bloc": "Wound Up",
  "Route de la soie": "Silk Road",
  "Récupération": "Recovery",
  "Réinjection": "Feedback Loop",
  "Sa bande de poussins le suit en file, et file picorer les bad vibes.": "Their band of chicks trails them in single file, then breaks rank to peck the bad vibes.",
  "Scène {stage} sur {total}": "Stage {stage} of {total}",
  "Serres": "Talons",
  "Ses lucioles filent piquer les bad vibes et reviennent, plus nombreuses la nuit.": "Their fireflies dart out to sting the bad vibes and come back, more of them at night.",
  "Ses notes repartent en échos comme un delay de dub, et rien ne le ralentit.": "Their notes bounce back as echoes like a dub delay, and nothing slows them down.",
  "Sous la coupole": "Under the Cupola",
  "Sous la voile": "Under the Sail",
  "Sprint final": "Final Sprint",
  "Ta cascade frappe deux fois plus fort.": "Your cascade hits twice as hard.",
  "Ta cascade frappe plus fort.": "Your cascade hits harder.",
  "Ta cascade frappe trois fois plus fort.": "Your cascade hits three times as hard.",
  "Ta cascade revient bien plus vite.": "Your cascade comes back much faster.",
  "Ta cascade revient plus vite.": "Your cascade comes back faster.",
  "Ta cascade revient presque en continu.": "Your cascade comes back almost non-stop.",
  "Ta débandade piétine deux fois plus fort.": "Your stampede tramples twice as hard.",
  "Ta débandade piétine plus fort.": "Your stampede tramples harder.",
  "Ta débandade piétine trois fois plus fort.": "Your stampede tramples three times as hard.",
  "Ta débandade revient bien plus vite.": "Your stampede comes back much faster.",
  "Ta débandade revient plus vite.": "Your stampede comes back faster.",
  "Ta débandade revient presque aussitôt.": "Your stampede comes back almost at once.",
  "Ta spéciale dure bien plus longtemps.": "Your special lasts much longer.",
  "Ta spéciale dure deux fois plus longtemps.": "Your special lasts twice as long.",
  "Ta spéciale dure plus longtemps.": "Your special lasts longer.",
  "Ta spéciale déchaîne aussi les deux éléments suivants.": "Your special also unleashes the next two elements.",
  "Ta spéciale déchaîne aussi l’élément suivant.": "Your special also unleashes the next element.",
  "Ta spéciale déchaîne les quatre éléments à la fois.": "Your special unleashes all four elements at once.",
  "Ta spéciale déchaîne ses éléments en bien plus grand.": "Your special unleashes its elements much bigger.",
  "Ta spéciale déchaîne ses éléments en démesure.": "Your special unleashes its elements larger than life.",
  "Ta spéciale déchaîne ses éléments en plus grand.": "Your special unleashes its elements bigger.",
  "Ta spéciale fond deux fois plus fort.": "Your special swoops twice as hard.",
  "Ta spéciale fond nettement plus fort.": "Your special swoops a lot harder.",
  "Ta spéciale fond plus fort.": "Your special swoops harder.",
  "Ta spéciale libère deux lucioles de plus.": "Your special lets out two more fireflies.",
  "Ta spéciale libère quatre lucioles de plus.": "Your special lets out four more fireflies.",
  "Ta spéciale libère six lucioles de plus.": "Your special lets out six more fireflies.",
  "Ta spéciale s’étend moitié plus loin autour de toi.": "Your special reaches half again as far around you.",
  "Ta spéciale s’étend nettement plus loin autour de toi.": "Your special reaches a lot farther around you.",
  "Ta spéciale s’étend plus loin autour de toi.": "Your special reaches farther around you.",
  "Ta spéciale éclate nettement plus large et plus fort.": "Your special bursts a lot wider and harder.",
  "Ta spéciale éclate plus large et plus fort.": "Your special bursts wider and harder.",
  "Ta spéciale éclate presque deux fois plus large, et fort.": "Your special bursts nearly twice as wide, and hits hard.",
  "Temps suspendu": "Suspended Time",
  "Tes bâtons lumineux frappent moitié plus large.": "Your glowsticks hit half again as wide.",
  "Tes bâtons lumineux frappent nettement plus large.": "Your glowsticks hit a lot wider.",
  "Tes bâtons lumineux frappent plus large.": "Your glowsticks hit wider.",
  "Tes dragons filent deux fois plus vite et plus loin.": "Your dragons fly twice as fast and far.",
  "Tes dragons filent nettement plus vite et plus loin.": "Your dragons fly a lot faster and farther.",
  "Tes dragons filent plus vite et plus loin.": "Your dragons fly faster and farther.",
  "Tes lucioles piquent deux bad vibes de plus en chemin.": "Your fireflies sting two more bad vibes on the way.",
  "Tes lucioles piquent trois bad vibes de plus en chemin.": "Your fireflies sting three more bad vibes on the way.",
  "Tes lucioles piquent une bad vibe de plus en chemin.": "Your fireflies sting one more bad vibe on the way.",
  "Tes massues traversent deux bad vibes de plus.": "Your clubs go through two more bad vibes.",
  "Tes massues traversent trois bad vibes de plus.": "Your clubs go through three more bad vibes.",
  "Tes massues traversent une bad vibe de plus.": "Your clubs go through one more bad vibe.",
  "Tes massues volent deux fois plus vite et plus loin.": "Your clubs fly twice as fast and far.",
  "Tes massues volent nettement plus vite et plus loin.": "Your clubs fly a lot faster and farther.",
  "Tes massues volent plus vite et plus loin.": "Your clubs fly faster and farther.",
  "Tes notes ont deux échos de plus.": "Your notes get two more echoes.",
  "Tes notes ont trois échos de plus.": "Your notes get three more echoes.",
  "Tes notes ont un écho de plus.": "Your notes get one more echo.",
  "Tes poussins donnent deux coups de bec de plus.": "Your chicks peck two more times.",
  "Tes poussins donnent trois coups de bec de plus.": "Your chicks peck three more times.",
  "Tes poussins donnent un coup de bec de plus.": "Your chicks peck one more time.",
  "Tes racines poussent bien plus vite.": "Your roots grow much faster.",
  "Tes racines poussent deux fois plus vite.": "Your roots grow twice as fast.",
  "Tes racines poussent plus vite.": "Your roots grow faster.",
  "Tes échos frappent moitié plus fort.": "Your echoes hit half again as hard.",
  "Tes échos frappent nettement plus fort.": "Your echoes hit a lot harder.",
  "Tes échos frappent plus fort.": "Your echoes hit harder.",
  "Tes éléments tiennent deux temps de plus.": "Your elements last two more beats.",
  "Tes éléments tiennent trois temps de plus.": "Your elements last three more beats.",
  "Tes éléments tiennent un temps de plus.": "Your elements last one more beat.",
  "Tes étoiles se relient de moitié plus loin.": "Your stars link from half again as far away.",
  "Tes étoiles se relient de nettement plus loin.": "Your stars link from a lot farther away.",
  "Tes étoiles se relient de plus loin.": "Your stars link from farther away.",
  "Ton ballon fait deux rebonds de plus.": "Your ball bounces two more times.",
  "Ton ballon fait trois rebonds de plus.": "Your ball bounces three more times.",
  "Ton ballon fait un rebond de plus.": "Your ball bounces once more.",
  "Ton ballon file deux fois plus vite et plus loin.": "Your ball flies twice as fast and far.",
  "Ton ballon file nettement plus vite et plus loin.": "Your ball flies a lot faster and farther.",
  "Ton ballon file plus vite et plus loin.": "Your ball flies faster and farther.",
  "Ton dermographe lâche deux dragons de plus à chaque temps.": "Your tattoo machine lets out two more dragons on every beat.",
  "Ton dermographe lâche trois dragons de plus à chaque temps.": "Your tattoo machine lets out three more dragons on every beat.",
  "Ton dermographe lâche un dragon de plus à chaque temps.": "Your tattoo machine lets out one more dragon on every beat.",
  "Ton grand pas frappe deux fois plus fort.": "Your long stride hits twice as hard.",
  "Ton grand pas frappe plus fort.": "Your long stride hits harder.",
  "Ton grand pas frappe trois fois plus fort.": "Your long stride hits three times as hard.",
  "Ton grand pas revient bien plus vite.": "Your long stride comes back much faster.",
  "Ton grand pas revient plus vite.": "Your long stride comes back faster.",
  "Ton grand pas revient presque aussitôt.": "Your long stride comes back almost at once.",
  "Ton haut-de-forme lâche deux tirs de plus.": "Your top hat lets loose two more shots.",
  "Ton haut-de-forme lâche trois tirs de plus.": "Your top hat lets loose three more shots.",
  "Ton haut-de-forme lâche un tir de plus.": "Your top hat lets loose one more shot.",
  "Ton mandala revient bien plus vite.": "Your mandala comes back much faster.",
  "Ton mandala revient plus vite.": "Your mandala comes back faster.",
  "Ton mandala revient presque aussitôt.": "Your mandala comes back almost at once.",
  "Ton mandala s’élargit et frappe plus fort.": "Your mandala widens and hits harder.",
  "Ton mandala s’élargit nettement et frappe plus fort.": "Your mandala widens a lot and hits harder.",
  "Ton mandala s’étend presque au double et frappe fort.": "Your mandala nearly doubles in size and hits hard.",
  "Ton portail lâche deux météores de plus, un par temps.": "Your portal drops two more meteors, one per beat.",
  "Ton portail lâche quatre météores de plus, un par temps.": "Your portal drops four more meteors, one per beat.",
  "Ton portail lâche trois météores de plus, un par temps.": "Your portal drops three more meteors, one per beat.",
  "Ton rayon devient immense et tes croissants énormes.": "Your ray turns huge and your crescents enormous.",
  "Ton rayon s’élargit bien et tes croissants grossissent bien.": "Your ray widens a lot and your crescents grow a lot.",
  "Ton rayon s’élargit et tes croissants grossissent.": "Your ray widens and your crescents grow.",
  "Ton renard fait deux sauts de plus.": "Your fox leaps two more times.",
  "Ton renard fait trois sauts de plus.": "Your fox leaps three more times.",
  "Ton renard fait un saut de plus.": "Your fox leaps once more.",
  "Ton sprint final renverse deux fois plus fort.": "Your final sprint knocks twice as hard.",
  "Ton sprint final renverse plus fort.": "Your final sprint knocks harder.",
  "Ton sprint final renverse trois fois plus fort.": "Your final sprint knocks three times as hard.",
  "Ton sprint final revient bien plus vite.": "Your final sprint comes back much faster.",
  "Ton sprint final revient plus vite.": "Your final sprint comes back faster.",
  "Ton sprint final revient presque aussitôt.": "Your final sprint comes back almost at once.",
  "Ton tir chargé traverse deux bad vibes de plus.": "Your charged shot goes through two more bad vibes.",
  "Ton tir chargé traverse trois bad vibes de plus.": "Your charged shot goes through three more bad vibes.",
  "Ton tir chargé traverse une bad vibe de plus.": "Your charged shot goes through one more bad vibe.",
  "Ton élément touche aussi les bad vibes autour, plus loin.": "Your element also hits the bad vibes around it, farther out.",
  "Ton élément touche aussi les bad vibes juste autour.": "Your element also hits the bad vibes right around it.",
  "Ton élément touche aussi les bad vibes, bien plus loin.": "Your element also hits the bad vibes, much farther out.",
  "Tous tes bâtons lumineux éclatent d’un coup, puis se rallument.": "All your glowsticks burst at once, then light back up.",
  "Tout ralentit autour de toi, sauf tes échos, qui se répètent une fois de plus.": "Everything slows down around you, except your echoes, which repeat once more.",
  "Toute ta bande charge d’un coup là où tu vises et renverse ce qu’elle piétine.": "Your whole band charges at once where you aim and knocks down whatever it tramples.",
  "Toutes les scènes, tous les sunrises : le sound system a tenu le festival entier.": "Every stage, every sunrise: the sound system held the whole festival.",
  "Toutes tes massues partent d’un coup, rebondissent de bad vibe en bad vibe et te reviennent.": "All your clubs fly off at once, bounce from bad vibe to bad vibe and come back to you.",
  "Trois lucioles de plus volent avec toi.": "Three more fireflies fly with you.",
  "Trois poussins de plus marchent dans ta bande.": "Three more chicks walk in your band.",
  "Tu gagnes deux rayons le jour et deux croissants la nuit.": "You gain two rays by day and two crescents by night.",
  "Tu gagnes trois rayons le jour, trois croissants la nuit.": "You gain three rays by day, three crescents by night.",
  "Tu gagnes un rayon le jour et un croissant la nuit.": "You gain one ray by day and one crescent by night.",
  "Tu gardes deux étoiles de plus au sol.": "You keep two more stars on the ground.",
  "Tu gardes trois étoiles de plus au sol.": "You keep three more stars on the ground.",
  "Tu gardes une étoile de plus au sol.": "You keep one more star on the ground.",
  "Tu ouvres ta lanterne et une nuée de lucioles pique les bad vibes devant toi, plus encore la nuit.": "You open your lantern and a swarm of fireflies stings the bad vibes ahead of you, even more at night.",
  "Tu ouvres un portail là où tu vises, d’où tombent en rythme les météores d’une autre galaxie.": "You open a portal where you aim, and meteors from another galaxy fall from it in rhythm.",
  "Tu plantes deux bâtons lumineux de plus à la fois.": "You plant two more glowsticks at a time.",
  "Tu plantes quatre bâtons lumineux de plus à la fois.": "You plant four more glowsticks at a time.",
  "Tu plantes six bâtons lumineux de plus à la fois.": "You plant six more glowsticks at a time.",
  "Tu sprintes, l’Élan à fond, et renverses toutes les bad vibes que tu traverses.": "You sprint, Momentum maxed, and knock down every bad vibe you run through.",
  "Tu traces devant toi un mandala qui frappe en rythme les bad vibes qui marchent dessus.": "You draw a mandala ahead of you that hits the bad vibes walking on it, in rhythm.",
  "Un hibou plane au-dessus de toi et fond sur les bad vibes, qu’il fige sur place.": "An owl glides above you and swoops on the bad vibes, freezing them in place.",
  "Un poussin de plus marche dans ta bande.": "One more chick walks in your band.",
  "Un rayon de soleil le jour, des croissants de lune la nuit : son horloge bascule toutes les quatre mesures.": "A ray of sun by day, moon crescents by night: their clock flips every four bars.",
  "Une enjambée où tu vises, qui frappe et étourdit sur le temps à l’arrivée.": "A stride to where you aim that hits and stuns on the beat as you land.",
  "Une luciole de plus vole avec toi.": "One more firefly flies with you.",
  "Une prise qui grésille, et coupe le son une mesure sur quatre.": "A crackling plug that cuts the sound one bar out of four.",
  "Une tête de moustique et sa nuée, qui pique et revient gorgée.": "A mosquito head and its swarm, which stings and comes back gorged.",
  "Vers": "Toward",
  "Voie lactée": "Milky Way",
  "bad vibes plus nombreuses": "more bad vibes",
  "bad vibes plus rapides": "faster bad vibes",
  "boss plus coriace": "tougher boss",
  "la musique s’est arrêtée": "the music stopped",
  "tenue": "held",
  "{count} boss en plus": {
    "one": "{count} extra boss",
    "other": "{count} extra bosses"
  },
  "{count} scènes tenues, puis la musique s’est arrêtée sur {stage}.": {
    "one": "{count} stage held, then the music stopped on {stage}.",
    "other": "{count} stages held, then the music stopped on {stage}."
  },
  "{percent} % de vie et de coups en plus pour les bad vibes": "{percent}% more health and damage for the bad vibes",
  "{stage} a tenu": "{stage} held",
  "{time} de marche": "{time} walk",
  "Échasses à ressort": "Spring Stilts",
  "Éclipse": "Eclipse",
  "Éclipse totale": "Total Eclipse",
  "Élan": "Momentum",
  "≈ {minutes} min · {bpm} BPM": "≈ {minutes} min · {bpm} BPM"
}
